<template>
  <button
    class="flex items-center border space-x-3 rounded-lg font-semibold transition duration-150 focus:outline-none focus:shadow-outline"
    :class="[buttonSize, bgColor, color, borderColor, hoverBg, hoverColor, hoverBorder]"
    @click="$emit('click', $event)"
    :disabled="disabled"
  >
    <icon-svg :class="[iconColor, iconSize]" v-if="useLeftIcon" :icon="icon" />
    <span>
      <slot></slot>
    </span>
    <icon-svg :class="[iconColor, iconSize]" v-if="useRightIcon" :icon="icon" />
  </button>
</template>

<script>
import IconSvg from "../IconSvg";
export default {
  name: "BaseButton",
  inheritAttrs: false,
  components: {
    IconSvg,
  },
  props: {
    bgColor: {
      default: "bg-primary",
      type: String,
    },
    borderColor: {
      default: "border-primary",
      type: String,
    },
    color: {
      default: "text-white",
      type: String,
    },
    hoverBg: {
      default: "hover:bg-primary-400",
      type: String,
    },
    hoverBorder: {
      default: "hover:border-primary-400",
      type: String,
    },
    hoverColor: {
      default: "hover:text-white",
      type: String,
    },
    size: {
      default: "medium",
      type: String,
      validator: (value) => {
        const sizes = ["small", "medium", "large"];
        return sizes.includes(value);
      },
    },
    icon: {
      default: null,
      type: String,
    },
    iconPosition: {
      default: "right",
      type: String,
      validator: (value) => {
        return value === "left" || value === "right";
      },
    },
    iconColor: {
      default: null,
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconSize() {
      if (this.size === "medium") {
        return "w-4";
      } else if (this.size === "small") {
        return "w-3";
      } else {
        return "w-4";
      }
    },
    useLabel() {
      return this.label !== null;
    },
    useLeftIcon() {
      return this.icon !== null && this.iconPosition === "left";
    },
    useRightIcon() {
      return this.icon !== null && this.iconPosition === "right";
    },
    buttonSize() {
      if (this.size === "small") {
        return "py-2 px-3 text-sm";
      } else if (this.size === "medium") {
        return "py-2 px-4";
      } else {
        return "py-3 px-5";
      }
    },
  },
};
</script>
